import Experience from '../Experience'
import Desk from './Desk'
import Particles from './Particles'
import Sofa from './Sofa'
import Tv from './Tv'
import Apropos from '../../sections/apropos/Apropos'
import Projets from '../../sections/projets/Projets'
import * as THREE from 'three'
import Accompagnement from '../../sections/accompagnement/Accompagnement'

export default class World {
  constructor() {
    //setup
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.resources = this.experience.resources
    this.particles = new Particles()
    this.sizes = this.experience.sizes
    this.camera = this.experience.camera

    // wait for resources and load world elements
    this.resources.on('ready', () => {
      //Models
      this.desk = new Desk()
      this.tv = new Tv()
      this.sofa = new Sofa()

      //Sections
      this.apropos = new Apropos()
      this.projets = new Projets()
      this.accompagnement = new Accompagnement()
    })

    this.pointofInterests()
  }
  pointofInterests() {
    this.main = document.querySelector('main')
    /**
     * DeskPoint
     */
    this.deskPoint = document.createElement('div')
    this.main.appendChild(this.deskPoint)
    this.deskPoint.classList.add('deskPoint', 'PointOfInterest')
    this.deskPoint.innerText = 'À propos'

    /**
     * sofaPoint
     */
    this.sofaPoint = document.createElement('div')
    this.main.appendChild(this.sofaPoint)
    this.sofaPoint.classList.add('sofaPoint', 'PointOfInterest')
    this.sofaPoint.innerText = 'Accompagnement'

    /**
     * tvPoint
     */
    this.tvPoint = document.createElement('div')
    this.main.appendChild(this.tvPoint)
    this.tvPoint.classList.add('tvPoint', 'PointOfInterest')
    this.tvPoint.innerText = 'Projets'

    this.points = [
      {
        position: new THREE.Vector3(-9, 0, 0),
        element: this.deskPoint,
      },
      {
        position: new THREE.Vector3(-2, 0, 0),
        element: this.sofaPoint,
      },
      {
        position: new THREE.Vector3(8, 0, 0),
        element: this.tvPoint,
      },
    ]
    this.rayCaster = new THREE.Raycaster()
  }
  updatePoints() {
    for (const point of this.points) {
      const screenPosition = point.position.clone()
      screenPosition.project(this.camera.instance)

      this.rayCaster.setFromCamera(screenPosition, this.camera.instance)

      const translateX = screenPosition.x * this.sizes.width * 0.5
      const translateY = -screenPosition.y * this.sizes.width * 0.5
      point.element.style.transform = `translate(${translateX}px, ${translateY}px)`
    }
  }
  update() {
    this.updatePoints()
    this.particles.update()

    if (this.apropos) {
      this.apropos.update()
    }
    if (this.accompagnement) {
      this.accompagnement.update()
    }
  }
  resize() {
    if (window.matchMedia('(min-width: 960px)').matches) {
      this.points[0].position = new THREE.Vector3(-9, 0, 0)
      this.points[1].position = new THREE.Vector3(-2, 0, 0)
      this.points[2].position = new THREE.Vector3(7, 0, 0)
    } else if (window.matchMedia('(min-width: 720px)').matches) {
      this.points[0].position = new THREE.Vector3(-6, 0, 0)
      this.points[1].position = new THREE.Vector3(-2, 0, 0)
      this.points[2].position = new THREE.Vector3(4, 0, 0)
    } else if (window.matchMedia('(min-width: 480px)').matches) {
      this.points[0].position = new THREE.Vector3(-5, 0, 0)
      this.points[1].position = new THREE.Vector3(-2, 0, 0)
      this.points[2].position = new THREE.Vector3(3, 0, 0)
    } else {
      this.points[0].position = new THREE.Vector3(-1, 0, 0)
      this.points[1].position = new THREE.Vector3(-1.7, -3, 0)
      this.points[2].position = new THREE.Vector3(-1, -6, 0)
    }
  }
}
